import React from 'react';
import { FaReact, FaNodeJs, FaVuejs, FaAngular, FaAws, FaDocker } from 'react-icons/fa';
import { SiTypescript, SiFirebase, SiFlutter, SiTailwindcss, SiMongodb, SiGraphql } from 'react-icons/si';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';

const TechStack = () => {
  const { currentTheme } = useTheme();
  const { currentLanguage } = useLanguage();
  
  const technologies = [
    { name: 'React', icon: <FaReact />, color: '#61DAFB' },
    { name: 'Node.js', icon: <FaNodeJs />, color: '#68A063' },
    { name: 'TypeScript', icon: <SiTypescript />, color: '#3178C6' },
    { name: 'Firebase', icon: <SiFirebase />, color: '#FFCA28' },
    { name: 'Flutter', icon: <SiFlutter />, color: '#54C5F8' },
    { name: 'Vue.js', icon: <FaVuejs />, color: '#4FC08D' },
    { name: 'Angular', icon: <FaAngular />, color: '#DD0031' },
    { name: 'Tailwind CSS', icon: <SiTailwindcss />, color: '#38B2AC' },
    { name: 'MongoDB', icon: <SiMongodb />, color: '#47A248' },
    { name: 'AWS', icon: <FaAws />, color: '#FF9900' },
    { name: 'Docker', icon: <FaDocker />, color: '#2496ED' },
    { name: 'GraphQL', icon: <SiGraphql />, color: '#E535AB' },
  ];
  
  // Translations
  const translations = {
    ru: {
      title: "Наш технологический стек",
      description: "Мы работаем с самыми современными и востребованными технологиями, обеспечивая высокое качество и производительность разрабатываемых решений."
    },
    en: {
      title: "Our Technology Stack",
      description: "We work with the most modern and in-demand technologies, ensuring high quality and performance of the solutions we develop."
    }
  };
  
  // Get translated text
  const getText = (key) => translations[currentLanguage]?.[key] || translations.ru[key];

  return (
    <div id="tech-stack" className={`py-16 ${
      currentTheme === 'light' 
        ? 'bg-gradient-to-b from-white to-gray-50'
        : 'bg-gradient-to-b from-[#0a0a0a] to-[#121212]'
    }`}>
      <div className="container mx-auto px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className={`bg-clip-text text-transparent bg-gradient-to-r ${
              currentTheme === 'light'
                ? 'from-light-primary to-light-secondary'
                : 'from-dark-primary to-dark-secondary'
            }`}>
              {getText('title')}
            </span>
          </h2>
          <p className={`max-w-2xl mx-auto ${
            currentTheme === 'light' ? 'text-gray-600' : 'text-gray-400'
          }`}>
            {getText('description')}
          </p>
        </div>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8">
          {technologies.map((tech, index) => (
            <div 
              key={index}
              className={`flex flex-col items-center justify-center p-6 rounded-xl transition-all duration-300 transform hover:-translate-y-2 group ${
                currentTheme === 'light'
                  ? 'bg-white border border-gray-200 hover:border-light-primary shadow-sm'
                  : 'bg-[#0F0F0F] border border-[#222] hover:border-dark-primary'
              }`}
            >
              <div 
                className="text-4xl mb-3 transition-colors duration-300 group-hover:text-dark-primary"
                style={{ color: tech.color }}
              >
                {tech.icon}
              </div>
              <span className={`transition-colors duration-300 ${
                currentTheme === 'light'
                  ? 'text-gray-700 group-hover:text-gray-900'
                  : 'text-gray-300 group-hover:text-white'
              }`}>
                {tech.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechStack; 